import * as React from 'react';
import { emojiFromUnicode, emojiLists, EmojiCategories } from './emojis';
import { Tabs, TabData } from '@wix/answers-ui-libby';

export const emojiPickerKey = 'emoji-picker';

export type EmojiPickerProps = {
	onSelectEmoji: (emoji: string) => void;
};

export type EmojiPickerState = {
	emojiList: any[];
	selected: string;
};

export const categories = Object.keys(emojiLists).map((key) => ({key, emoji: emojiLists[key][0].unicode}));

export class EmojiPicker extends React.PureComponent<EmojiPickerProps, EmojiPickerState> {

	state: EmojiPickerState = {
		emojiList: emojiLists[categories[0].key],
		selected: categories[0].key
	};

	renderEmoji = (emoji: string, i: number) => {
		const onSelectEmoji = () => this.props.onSelectEmoji(emoji);
		return (
			<div className='emoji' id={emoji} key={i} onClick={onSelectEmoji}> {emojiFromUnicode(emoji)} </div>
		);
	}

	changeEmojiTab = (id: EmojiCategories) => {
		const newList = emojiLists[id];
		this.setState({emojiList: newList, selected: id});
	}

	render () {

		const tabItems: TabData[] = categories.map((item) => ({element: emojiFromUnicode(item.emoji), id: item.key}));

		return (
			<div className={emojiPickerKey}>
				<Tabs items={tabItems} onChange={this.changeEmojiTab} selected={this.state.selected} />
				<div className='emoji-list'>
					{this.state.emojiList.map((item, i) => this.renderEmoji(item.unicode, i))}
				</div>
			</div>
		);
	}
}
